"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var URLsManager_less_1 = __importDefault(require("./URLsManager.less"));
var components_1 = require("stremio/components");
var Item_1 = __importDefault(require("./Item"));
var AddItem_1 = __importDefault(require("./AddItem"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var useStreamingServerUrls_1 = __importDefault(require("./useStreamingServerUrls"));
var CONSTANTS_1 = require("../../../../common/CONSTANTS");
var hasBeenInjected_1 = require("../../../../common/hasBeenInjected");
var URLsManager = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = (0, react_1.useState)(false), addMode = _a[0], setAddMode = _a[1];
    var _b = (0, useStreamingServerUrls_1.default)(), streamingServerUrls = _b.streamingServerUrls, addServerUrl = _b.addServerUrl, reloadServer = _b.reloadServer, selectServerUrl = _b.selectServerUrl;
    (0, react_1.useEffect)(function () {
        if (!(0, hasBeenInjected_1.getInjectionStatus)().streamingServer) {
            addServerUrl(CONSTANTS_1.DEFAULT_STREAMING_SERVER_URL);
            setTimeout(function () {
                selectServerUrl(CONSTANTS_1.DEFAULT_STREAMING_SERVER_URL);
                (0, hasBeenInjected_1.setInjected)("streamingServer");
                console.log("Injected streaming server \"".concat(CONSTANTS_1.DEFAULT_STREAMING_SERVER_URL, "\""));
            }, 1000);
        }
    }, [streamingServerUrls]);
    var onAdd = function () {
        setAddMode(true);
    };
    var onCancel = function () {
        setAddMode(false);
    };
    var handleAddUrl = (0, react_1.useCallback)(function (url) {
        addServerUrl(url);
        setAddMode(false);
    }, []);
    return (react_1.default.createElement("div", { className: URLsManager_less_1.default['wrapper'] },
        react_1.default.createElement("div", { className: URLsManager_less_1.default['header'] },
            react_1.default.createElement("div", { className: URLsManager_less_1.default['label'] }, t('URL')),
            react_1.default.createElement("div", { className: URLsManager_less_1.default['label'] }, t('STATUS'))),
        react_1.default.createElement("div", { className: URLsManager_less_1.default['content'] },
            streamingServerUrls.map(function (item) { return (react_1.default.createElement(Item_1.default, __assign({ key: item.url }, item))); }),
            addMode ?
                react_1.default.createElement(AddItem_1.default, { onCancel: onCancel, handleAddUrl: handleAddUrl })
                : null),
        react_1.default.createElement("div", { className: URLsManager_less_1.default['footer'] },
            react_1.default.createElement(components_1.Button, { title: t('SETTINGS_SERVER_ADD_URL'), className: URLsManager_less_1.default['add-url'], onClick: onAdd },
                react_1.default.createElement(react_2.default, { name: 'add', className: URLsManager_less_1.default['icon'] }),
                t('SETTINGS_SERVER_ADD_URL')),
            react_1.default.createElement(components_1.Button, { className: URLsManager_less_1.default['reload'], title: t('RELOAD'), onClick: reloadServer },
                react_1.default.createElement(react_2.default, { name: 'reset', className: URLsManager_less_1.default['icon'] }),
                react_1.default.createElement("div", { className: URLsManager_less_1.default['label'] }, t('RELOAD'))))));
};
exports.default = URLsManager;
